import { NavegacaoStore, rastrearBlocoMenu } from '@/layout/store/navegacao.store';
import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [AppMenuitem, RouterModule],
  template: `<ul class="layout-menu">
    @if (semResultadosBuscaMenu()) {
      <li class="px-4 pt-6 text-sm list-none text-center text-surface-500">Nenhum item encontrado</li>
    }
    @for (item of store.itensMenu(); track rastrearBlocoMenu($index, item); let i = $index) {
      @if (!item.separator) {
        <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
      }
      @if (item.separator) {
        <li class="menu-separator"></li>
      }
    }
  </ul>`,
})
export class AppMenu {
  protected readonly store = inject(NavegacaoStore);
  protected readonly rastrearBlocoMenu = rastrearBlocoMenu;

  protected readonly semResultadosBuscaMenu = computed(
    () => this.store.termoBuscaMenu().trim().length > 0 && this.store.itensMenu().length === 0,
  );
}
